module.exports = __webpack_public_path__ + "img/Piger.16d6e0cf.jpg";